import Swiper from 'swiper';
import { Navigation, Pagination  } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export function initHistory() {
    const timelineSwiper = new Swiper('.kn_company-history__slider', {
        modules: [Navigation, Pagination],
        slidesPerView: 'auto',
        spaceBetween: 30,
        pagination: {
            el: '.kn_company-history .swiper-pagination',
            type: 'progressbar'
        },
        navigation: {
            nextEl: '.kn_company-history .swiper-button-next',
            prevEl: '.kn_company-history .swiper-button-prev'
        }
    });
}